import useReveal from "../hooks/useReveal";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock/mock";

export default function Services() {
  const [ref, inView] = useReveal();

  return (
    <section id="services" className="py-24 md:py-32 bg-[#FBF8F3]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={ref} className={`text-center max-w-2xl mx-auto mb-16 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-[#A17E4A] tracking-[0.25em] uppercase text-xs mb-4">What We Do</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2A2521] mb-5">
            Quality Blinds & Elegant Draperies
          </h2>
          <p className="text-[#6B6259] text-lg">
            From consultation to installation, every step is crafted around your home and your taste.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div
              key={s.slug}
              className={`group relative overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-2xl transition-all duration-500 reveal ${
                inView ? "in-view" : ""
              }`}
              style={{ animationDelay: `${i * 90}ms` }}
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-60" />
              </div>
              <div className="p-7">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-serif text-xl text-[#2A2521] mb-3">{s.title}</h3>
                  <ArrowUpRight className="w-5 h-5 text-[#A17E4A] shrink-0 group-hover:rotate-45 transition-transform duration-300" />
                </div>
                <p className="text-[#6B6259] leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
